<template>
    <z-basePage :title="'岗位设置'">
        <div class="btns-top bottom">
            <div class="back-btn" @click="addItem">添加</div>
            <div class="back-btn blue" @click="save">保存</div>
        </div>

        <z-scrollDiv class="post-main" v-form="'back-post'">
            <div class="post-item" v-for="item in allPost" :key="item.id">
                <div class="back-item">
                    <div class="back-title">岗位名称</div>
                    <div class="back-wrap">
                        <el-input class="top-choose" rule="noVal" v-tar="item.positionName" v-model="item.positionName" >
                        </el-input>
                    </div>
                </div>
                <div class="back-item">
                    <div class="back-title">每级工资</div>
                    <div class="back-wrap">
                        <el-input class="top-choose" rule="noVal number positive" v-tar="item.gradeSalary" v-model="item.gradeSalary" >
                            <template slot="append">元</template>
                        </el-input>
                    </div>
                </div>
                <!-- <div class="back-btn red">删除</div> -->
            </div>
            <div class="post-item" v-for="(item,index) in add_list" :key="item.id">
                <div class="back-item">
                    <div class="back-title">岗位名称</div>
                    <div class="back-wrap">
                        <el-input class="top-choose" rule="noVal" v-tar="item.positionName" v-arg="'岗位名称'" v-model="item.positionName" >
                        </el-input>
                    </div>
                </div>
                <div class="back-item">
                    <div class="back-title">每级工资</div>
                    <div class="back-wrap">
                        <el-input class="top-choose" rule="noVal number positive" v-tar="item.gradeSalary" v-arg="'每级工资'" v-model="item.gradeSalary" >
                            <template slot="append">元</template>
                        </el-input>
                    </div>
                </div>
                <div class="back-btn red" @click="clearItem(index)">删除</div>
            </div>
            <z-noData :list="[...allPost,...add_list]"></z-noData>
        </z-scrollDiv>

    </z-basePage>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        data(){
            return {
                add_list:[],  //新添加的条目
            }
        },

        computed:{
            ...mapState(["allPost"]),
            all_list(){
                return [...allPost,...add_list];
            },
        },
        created(){
            this.getData();
        },

        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-post',path:to.path});
			next(res);
        },

        methods:{
            getData(){
                this.$func.getPost(true,list=>{
                    this.$form.init('back-post');
                });
            },
            addItem(){  //添加项目位置
                console.log("添加");
                this.add_list.push({
                    positionName:"",
                    gradeSalary:"",
                })
            },
            clearItem(index){  //删除项目位置
                this.add_list.splice(index,1);
            },
            makeArr(arr){  //制作传给后台的格式
                return arr.map(item=>{
                    return {
                        id:item.id,
                        position_name:item.positionName,
                        grade_salary:item.gradeSalary,
                    }
                });
            },
            save(){
                console.log("保存");
                let res = this.$form.check('back-post');
                console.log(res)
                if(!res){
                    return;
                }
                this.$func.loading(true);            
                let res_arr = this.makeArr(this.allPost).concat(this.makeArr(this.add_list));

                let url = `api/admin/cfg_position`;
                this.$http.post(url,{
                    data:JSON.stringify(res_arr),
                }).then(res=>{
                    if(res.status == 200){
                        this.add_list = [];
                        this.getData();
                        this.successTip("保存成功");
                    }
                    this.$func.loading(false);
                    
                }).catch(err=>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });
            },
        },
    }
</script>

<style lang="less" scoped>
    .btns-top{
        height: 40px;
        padding-bottom: 10px;
        box-sizing: border-box;
        margin-bottom: 0;
    }
    .post-main{
        height:calc(~"100% - 40px"); //减去了头部按钮部分高度
        box-sizing: border-box;
        padding-top: 0.1px;
    }
    .post-item{
        margin-top: 20px;
        border-bottom: 1px solid #ddd;
        position: relative;
        // padding-bottom: 35px;
        // position: relative;
        // .back-btn{
        //     position: absolute;
        //     right: 0;
        //     bottom: 5px;
        // }
        // &>.back-item:nth-last-child(2){
        //     margin-bottom: 0;
        // }
        .back-btn{
            position: absolute;
            bottom:26px;
            right:20px;
        }
    }
    .back-item{
        zoom: 1;
        &:after{
            content:"";
            display: block;
            clear: both;
        }
    }
    .back-title,.back-wrap{
        float:left;
    }
</style>





// WEBPACK FOOTER //
// page-post.vue?68123a1e